import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_5 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-plus-square" }, null, -1)
const _hoisted_8 = { class: "card-body py-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.pageTitle), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString("Počet záznamov: " + _ctx.tableData.length), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_row, { gutter: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.tableSearch,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tableSearch) = $event)),
                  size: "small",
                  placeholder: "Vyhľadať..."
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  style: {"width":"100%"},
                  onClick: _ctx.insertRecord,
                  type: "primary",
                  size: "small",
                  class: "btn btn-sm btn-primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(_ctx.insertButtonText), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_el_table, {
        data: _ctx.tableData.filter((data) => !_ctx.tableSearch || data.title.toLowerCase().includes(_ctx.tableSearch.toLowerCase())),
        "default-sort": { prop: _ctx.defaultSortField, order: 'ascending' },
        "empty-text": "Načítavajú sa údaje...",
        border: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentFields, (documentField) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: documentField.id,
              prop: documentField.field,
              label: documentField.name,
              formatter: 
            documentField.formatter == 'date'
              ? _ctx.dateFormatter
              : documentField.formatter == 'datetime'
              ? _ctx.datetimeFormatter
              : documentField.formatter == 'boolean'
              ? _ctx.booleanFormatter
              : documentField.formatter == 'programName'
              ? _ctx.programNameFormatter
              : documentField.formatter == 'statusName'
              ? _ctx.statusNameFormatter
              : documentField.formatter == 'address'
              ? _ctx.addressFormatter
              : undefined
          ,
              sortable: documentField.sortable ? 1 : undefined
            }, null, 8, ["prop", "label", "formatter", "sortable"]))
          }), 128)),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "Akcie",
            width: "150"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                size: "mini",
                title: "Upraviť",
                onClick: ($event: any) => (_ctx.editRecord(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_popconfirm, {
                title: "Naozaj chcete vymazať túto položku?",
                "confirm-button-text": "Áno, vymazať",
                "cancel-button-text": "Nie, nechcem vymazať",
                onConfirm: ($event: any) => (_ctx.confirmDelete(scope.row))
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "mini",
                    title: "Vymazať"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "default-sort"])
    ])
  ]))
}